import PartnershipContainer from './partnership_container';

const Partnership = PartnershipContainer;
export default Partnership;
